import React, { FC } from "react";

const PayRedirectView: FC = () => (
  <h1>Перенаправляем на сайт платёжной системы ...</h1>
);

export default PayRedirectView;
